import { Dispatch } from "redux";
import { createAddDocumentsAction, DocIdToDocument } from "../..";
import { constructDocumentDataFromDto, DocumentResponse } from "../../../..";
import { FeedItem } from "../../../../models/Feed";

export const processFeedResponse = (dispatch: Dispatch) => (results: DocumentResponse[]): FeedItem[] => {
    const docIdToDocument: DocIdToDocument = {}
    results.forEach(x => {
        const document = constructDocumentDataFromDto(x)

        docIdToDocument[x.Key] = {
            document,
            isUpdating: false,
            isDeleting: false,
            isFetching: false
        }
    })
    dispatch(createAddDocumentsAction(docIdToDocument))

    return results.map(x => ({
        docId: x.Key,
        whyDoISeeThisItem: x.Value.WhyDoISeeThisItem?x.Value.WhyDoISeeThisItem:"",
        commentsExpanded: false
    }))
}